import { motion } from 'framer-motion'
import { FaTimesCircle } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Cancel = () => {
    return (
        <div className='bg-surface-muted min-h-[85vh] flex items-center justify-center px-4 md:px-6 py-12'>
            <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className='bg-white w-full max-w-lg rounded-[2.5rem] md:rounded-card shadow-premium p-8 md:p-12 text-center'
            >
                <div className='w-20 h-20 md:w-24 md:h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8'>
                    <FaTimesCircle className='text-red-500 text-4xl md:text-5xl' />
                </div>

                <h1 className='text-2xl md:text-3xl font-black text-primary mb-3 md:mb-4 tracking-tight'>Payment Cancelled</h1>
                <p className='text-sm md:text-base text-gray-500 font-medium mb-8 md:mb-12 max-w-xs mx-auto leading-relaxed'>
                    No worries! Your order has been cancelled and no payment was processed. You can find your items still waiting in the cart.
                </p>

                <div className='flex flex-col sm:flex-row gap-3 md:gap-4 justify-center'>
                    <Link 
                        to="/cart" 
                        className='w-full sm:w-auto px-10 py-3.5 bg-primary text-white text-sm font-black rounded-full hover:bg-accent transition-all shadow-xl shadow-primary/20'
                    >
                        Return to Cart
                    </Link>
                    <Link 
                        to="/" 
                        className='w-full sm:w-auto px-10 py-3.5 border-2 border-primary text-primary text-sm font-black rounded-full hover:bg-primary hover:text-white transition-all'
                    >
                        Back to Shop
                    </Link>
                </div>
            </motion.div>
        </div>
    )
}

export default Cancel
